import queryString from 'query-string';


export function currentURL() {
  return window.location.href;
}

export function currentURLWithoutParams() {
  return window.location.protocol + '//' + window.location.host + window.location.pathname;
}

export function currentDomain() {
  return window.location.hostname;
}

export function appendQueryString(url, qs) {
  const parsed = queryString.parseUrl(url);
  qs = {...parsed.query,
    ...qs
  };

  Object.keys(qs).forEach((key) => (qs[key] === null || qs[key] === "") && delete qs[key]);
  let stringified = queryString.stringify(qs);
  if (!stringified) {
    return url;
  } else {
    return url + "?" + stringified;
  }
}

// {url: 'https://foo.bar', query: {foo: 'bar'}}
export function parseUrl(url) {
  return queryString.parseUrl(url);
}

// {foo: 'bar'}
export function parseQueryString(val) {
  return queryString.parse(val);
}

// foo=unicorn&ilike=pizza
export function stringifyQueryString(val) {
  return queryString.stringify(val);
}

export function removeQueryString(url) {
  return url.split("?")[0];
}

// See https://stackoverflow.com/a/43467144/1446284
export function isValidUrl(value) {
  if (!value) return false;
  if (value.startsWith("//")) value = value.replace("//", "https://");
  if (!value.startsWith("http://") && !value.startsWith("https://")) {
    value = `http://${value}`
  }

  let url;
  try {
    url = new URL(value);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}
